export const formatString = (string, delimiter = "_") => {
  let strArr = string.split("");
  return [strArr[0].toUpperCase(), ...strArr.splice(1)]
    .join("")
    .split(delimiter)
    .join(" ");
};
